import { getCorrectFilePath } from "@/helpers/new/getCorrectFilePath";

/**
 * Преобразует относительные пути изображений в абсолютные URL
 * @param {Array} content - Контент Tiptap
 * @returns {Array} Обработанный контент с абсолютными URL
*/

export const onvertingRelativeURLsToAbsoluteOnes = (content) => {
  if (!content || !Array.isArray(content)) return content;

  return content.map(item => {
    if (item.type === 'image' && item.attrs?.src) {
      return {
        ...item,
        attrs: {
          ...item.attrs,
          src: getCorrectFilePath(item.attrs.src)
        }
      };
    }
    
    // Рекурсивно обрабатываем вложенный контент
    if (item.content) {
      return {
        ...item,
        content: onvertingRelativeURLsToAbsoluteOnes(item.content)
      };
    }
    
    return item;
  });
};